import { Routes, Route } from "react-router-dom";
import AvatarPage from "./pages/AvatarPage";
import AdminPage from "./pages/AdminPage";

function App() {
  return (
    <Routes>
      <Route path="/" element={<AvatarPage />} />
      <Route path="/admin" element={<AdminPage />} />
    </Routes>
  );
}

export default App;
